module.exports = __webpack_public_path__ + "static/media/bleu2_optim.9442febd.jpg";